module.exports = __webpack_public_path__ + "img/23.2b9c4474.jpg";